import { Flex } from '@mantine/core';
import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useDealRestriction } from './useDealRestriction.ts';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch.tsx';
import { SettingsRowCard } from '../SettingsRowCard/SettingsRowCard.tsx';

interface Props {
	dealId: string;
	isRestricted: boolean;
	onUpdated?: () => void;
	// Deal Settings renders this as a standalone card; the fund drawer nests it in its own
	// section (under a Divider) and opts out of the chrome.
	withBorder?: boolean;
}

export const DealRestrictionToggle = ({ dealId, isRestricted, onUpdated, withBorder }: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();
	const { setRestriction, isPending, canManage } = useDealRestriction({ dealId, onUpdated });

	return (
		<Flex align="flex-start" justify="space-between" gap="1rem">
			<SettingsRowCard
				withBorder={withBorder}
				title={tAdminDashboard('deal_settings.restriction.title')}
				description={tAdminDashboard('deal_settings.restriction.description')}
				action={
					<AdvancedSwitch
						selectedValue={isRestricted}
						disabled={!canManage || isPending}
						onChange={(value) => setRestriction(Boolean(value))}
						dataTestId="deal-restriction-toggle"
					/>
				}
			/>
		</Flex>
	);
};
